export default function Center({ children }) {
  return (
    <div className="fixed flex-col items-center justify-center s-full top-0">
      {children}
    </div>
  );
}
